export const alertConstants = {
    SEND_ALERT_DATA:"SEND_ALERT_DATA"
};